<template>
    <div class="resource_subject_add_wrap">
        <div class="header">
            <el-button size="medium" @click="$router.back()">返回</el-button>
            <el-button size="medium" type="primary" @click="saveHandler">保存</el-button>
        </div>
        <div class="resource_subject_box" :style="`height: ${windowHeight - 170}px;`">
            <div class="resource_subject_content">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="所属模块" prop="moduleName">
                        <el-input v-model.trim="formData.moduleName" :maxlength="20" placeholder="请输入所属模块"></el-input>
                    </el-form-item>
                    <el-form-item label="模板名称" prop="tempName">
                        <el-input v-model.trim="formData.tempName" :maxlength="20" placeholder="请输入模板名称"></el-input>
                    </el-form-item>
                    <el-form-item label="模板内容" prop="tempContext">
                        <el-input type="textarea" v-model="formData.tempContext" :rows="4" :maxlength="1000" placeholder="请输入模板内容"></el-input>
                    </el-form-item>
                    <el-form-item label="模板分类" prop="tempType">
                        <el-select v-model="formData.tempType" placeholder="请选择模板分类" size="medium">
                            <el-option label="查询" :value="1"></el-option>
                            <el-option label="更新数据" :value="2"></el-option>
                            <el-option label="删除数据" :value="3"></el-option>
                            <el-option label="修改表结构" :value="4"></el-option>
                            <el-option label="删除表" :value="5"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                        <div>
                            1、模板名称请使用sql用途的简要描述，能够让客服一眼看懂该sql是什么功能
                        </div>
                        <div>
                            2、模板需要有一定的通用性，变量使用{n}进行标识，从0开始。
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize'
    import {
        sqlToolTemplateCreate,
    } from '@/api/sql'

    export default {
        name: "sqlTemplateAddEdit",
        data() {
            return {
                formData: {
                    moduleName: '',
                    tempContext: '',
                    tempName: '',
                    tempType: 1,
                },
                rules: {
                    tempType: [
                        {required: true, trigger: 'blur', message: '请选择模板分类'}
                    ],
                    tempName: [
                        {required: true, trigger: 'blur', message: '请填写模板名称'}
                    ],
                    moduleName: [
                        {required: true, trigger: 'blur', message: '请填写所属模块'}
                    ],
                    tempContext: [
                        {required: true, trigger: 'blur', message: '请输入模板内容'}
                    ],
                },
                id: this.$route.query.id,
                isEdit: !!this.$route.query.id
            }
        },
        mixins: [windowResize],
        created() {
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            saveHandler() {
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        sqlToolTemplateCreate({
                            moduleName: this.formData.moduleName,
                            tempContext: this.formData.tempContext,
                            tempName: this.formData.tempName,
                            tempType: this.formData.tempType,
                        })
                            .then(() => {
                                this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
                                this.$router.back();
                            })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import './../../styles/mixin';

    .resource_subject_add_wrap {
        padding: 12px;

        .header {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        .resource_subject_box {
            @include scrollBar;

            .resource_subject_content {
                width: 810px;
                margin: 0 auto;
                padding-top: 20px;

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/sql/sqlTemplateAddEdit.vue